"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDeleteTemplateModal = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var DpModal_1 = __importDefault(require("../Modal/DpModal"));
exports.StyledDeleteTemplateModal = (0, styled_components_1.default)(DpModal_1.default)(function (_a) {
    var _b = _a.theme, Colors = _b.Colors, Typography = _b.Typography;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: 9999;\n\n    .modal-header h1 {\n      font-weight: bold;\n    }\n\n    .modal-body p {\n      color: ", ";\n      font-size: ", ";\n\n      &.warning {\n        color: ", ";\n        font-size: ", ";\n        line-height: ", ";\n\n        i {\n          vertical-align: bottom;\n        }\n      }\n    }\n\n    .delete-button {\n      font-weight: bold;\n      letter-spacing: 2px;\n    }\n  "], ["\n    z-index: 9999;\n\n    .modal-header h1 {\n      font-weight: bold;\n    }\n\n    .modal-body p {\n      color: ", ";\n      font-size: ", ";\n\n      &.warning {\n        color: ", ";\n        font-size: ", ";\n        line-height: ", ";\n\n        i {\n          vertical-align: bottom;\n        }\n      }\n    }\n\n    .delete-button {\n      font-weight: bold;\n      letter-spacing: 2px;\n    }\n  "])), Colors.Typography.primary, Typography.Sizes.md, Colors.danger, Typography.Sizes.smd, Typography.Sizes.smd);
});
var templateObject_1;
